import React, { useState, useRef, useEffect, useMemo } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { BiSend } from "react-icons/bi";
import { Row, Col, Spinner } from "react-bootstrap";
import JoditEditor from "jodit-react";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import HandleHttpErrors from "../../HandleHttpErrors";
const baseURL = process.env.REACT_APP_API_JOBS;

export default function Add({
  increment,
  counter,
  moamad,
  mailTypeOptions,
  setNewEmail,
  setEmailToDisplay,
}) {
  const [newEmailToAdd, setNewEmailToAdd] = useState({
    mail_type: "",
    sender: "",
    subject: "",
    content: "",
    date: "",
    time: "",
    place: null,
    signJob: "",
    signName: "",
    mekhraz: moamad.mekhraz,
    moamad: moamad.id,
  });
  const navigate = useNavigate();
  const location = useLocation();
  const [places, setPlaces] = useState([]);
  const [loading, setLoading] = useState(false);
  const [displayDateTimePlace, setDisplayDateTimePlace] = useState(false);
  const [displaySignatrue, setDisplaySignatrue] = useState(false);
  const [meeting, setMeeting] = useState({});
  const axiosPrivate = useAxiosPrivate("application/json");
  const editor1 = useRef(null);
  const config = useMemo(
    () => ({
      readonly: false,
      height: 400,
      width: 600,
      askBeforePasteFromWord: false,
      askBeforePasteHTML: false,
      //colorPickerDefaultTab: "background",
      //buttons: ["brush"],
      toolbarAdaptive: false,
      disablePlugins: ["File", "Image", "Media"],
    }),
    []
  );
  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    const getPlaces = async () => {
      try {
        const response = await axiosPrivate.get(baseURL + "place/", {
          signal: controller.signal,
        });
        isMounted && setPlaces(response.data);
      } catch (err) {
        console.error(err);
        navigate("/login", { state: { from: location }, replace: true });
      }
    };

    getPlaces();
    return () => {
      isMounted = false;
      isMounted && controller.abort();
    };
  }, []);

  const handleDDSChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    const n = Number(value);
    setNewEmailToAdd((prevState) => ({
      ...prevState,
      [name]: n,
    }));
  };
  const handleChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    if (name == "mail_type") {
      if (value == "הזמנה לראיון" || value == "הזמנה למבחן") {
        setDisplayDateTimePlace(true);
      } else setDisplayDateTimePlace(false);
    }
    if (name == "mail_type") {
      if (value == "דואר חופשי") {
        setDisplaySignatrue(true);
      } else setDisplaySignatrue(false);
    }
    setNewEmailToAdd((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    let isMounted = true;
    const controller = new AbortController();
    const addData = async () => {
      try {
        const response = await axiosPrivate.post(
          "/jobs/moamademail/",
          newEmailToAdd,
          {
            signal: controller.signal,
          }
        );
        console.log("Dont delete1");

        //isMounted && setRefreshMoamads((prev) => !prev);

        setEmailToDisplay(response.data);

        setNewEmail(false);
        alert("המייל נשלח בהצלחה");
        setLoading(false);
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };
    console.log("rrrrrrrrrrrr", newEmailToAdd.mail_type);
    console.log("eeeeeeeeeeee", moamad.extention_date);
    if (
      newEmailToAdd.mail_type === "הארכת מועד הגשת מסמכים" &&
      (moamad.extention_date == null ||
        new Date(moamad.extention_date) < new Date())
    ) {
      alert("לא בוצעה הארכת מועד לשליחת מסמכים, לא נשלח דואר למועמד.");
      setTimeout(() => {
        setLoading(false); // Set loading state after alert
      }, 0);
    } else {
      addData();
    }
    return () => {
      isMounted = false;
      isMounted && controller.abort();
    };
  };

  // render
  if (loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <div className="text-center">
          <Spinner animation="border" variant="danger" visible />

          <br />
          <br />
          <h3 className="spinnerText">המתן עד סיום הפעולה.</h3>
        </div>
      </div>
    );
  } else {
    return (
      <div>
        <div className="border-danger container" bg="light">
          {/*  <div className="card text-dark bg-light container p-3  border">
        <Card className="border-danger container px-5" bg="light">*/}
          <div className="card-header">
            <h3 style={{ textAlign: "center" }}>
              שליחת דואר אלקטרוני ל: {moamad?.f_name}{" "}
              {moamad?.father_name ? moamad?.father_name + " " : ""}{" "}
              {moamad?.l_name}
            </h3>
          </div>
          <div className="card-body">
            <Row>
              <Col>
                <form onSubmit={handleSubmit} className="mbsc-form-group ">
                  <Row>
                    <Col>
                      <div className="form-group ">
                        <label htmlFor="mail_type">בחר סוג ההודעה: </label>
                        <select
                          name="mail_type"
                          onChange={handleChange}
                          value={newEmailToAdd.mail_type}
                          required
                        >
                          <option key="0" value="" selected>
                            בחר סוג
                          </option>
                          {mailTypeOptions?.map((a) => (
                            <option key={a[0]} value={a[1]}>
                              {a[1]}
                            </option>
                          ))}
                        </select>
                      </div>
                    </Col>

                    <Col>
                      <div className="form-group">
                        <label htmlFor="subject">תוספת לכותרת של המייל</label>
                        <input
                          type="text"
                          name="subject"
                          className="form-control"
                          id="subject"
                          defaultValue={newEmailToAdd.subject}
                          placeholder="התוכן יתווסף לנושא הדואר האלקטרוני "
                          onChange={handleChange}
                        />
                      </div>
                    </Col>
                  </Row>
                  {displayDateTimePlace && (
                    <Row style={{ float: "right" }}>
                      <Col>
                        <div className="form-group ">
                          <label htmlFor="date">תאריך</label>
                          <input
                            type="date"
                            name="date"
                            className="form-control"
                            id="date"
                            value={newEmailToAdd.date}
                            placeholder="תאריך ההזמנה"
                            onChange={handleChange}
                          />
                        </div>
                      </Col>
                      <Col>
                        <div className="form-group">
                          <label htmlFor="time">שעה</label>
                          <input
                            type="time"
                            name="time"
                            className="form-control"
                            id="time"
                            value={newEmailToAdd.time}
                            placeholder="שעה"
                            onChange={handleChange}
                          />
                        </div>
                      </Col>
                      <Col>
                        <div className="form-group">
                          <label htmlFor="place">מקום:</label>
                          <br />
                          <select
                            name="place"
                            onChange={handleDDSChange}
                            value={newEmailToAdd.place}
                            required
                          >
                            <option value="" selected>
                              בחר מקום
                            </option>
                            {places?.map((d) => (
                              <option key={d.id} value={d.id}>
                                {d.title}
                              </option>
                            ))}
                          </select>
                        </div>
                      </Col>
                    </Row>
                  )}
                  {displaySignatrue && (
                    <Row style={{ float: "right" }}>
                      <Col>
                        <div className="form-group ">
                          <label htmlFor="signName">שם החותם</label>
                          <input
                            type="text"
                            name="signName"
                            className="form-control"
                            id="signName"
                            value={newEmailToAdd.signName}
                            placeholder="שם החותם"
                            onChange={handleChange}
                          />
                        </div>
                      </Col>
                      <Col>
                        <div className="form-group">
                          <label htmlFor="signJob">תפקיד</label>
                          <input
                            type="text"
                            name="signJob"
                            className="form-control"
                            id="signJob"
                            value={newEmailToAdd.signJob}
                            placeholder="תאור התפקיד"
                            onChange={handleChange}
                          />
                        </div>
                      </Col>
                    </Row>
                  )}
                  <Row>
                    <Col>
                      <center>
                        <label htmlFor="content"> הערות נוספות</label>
                      </center>
                      <JoditEditor
                        editorRef={editor1}
                        name="content"
                        tabIndex={1}
                        value={newEmailToAdd.content}
                        config={config}
                        onBlur={(newContent) => {
                          setNewEmailToAdd((prevState) => ({
                            ...prevState,
                            content: newContent,
                          }));
                        }}
                      />
                    </Col>
                  </Row>

                  <button type="submit" className="btn btn-primary">
                    שלח <BiSend rotate={90} />
                  </button>
                </form>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    );
  }
}
